import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
export const RecaptchaWeb = forwardRef((props, ref) => (_jsx(ReCAPTCHA, { ref: ref, sitekey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '', ...props })));
//# sourceMappingURL=RecaptchaWeb.js.map